import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import Buttons from "../../../components/ui/button/Buttons";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";
import { AppIcons } from "../../../data/appIcons";

const initState = {
  isRedirection: 'no',
  scheduleType: 'physical',
};

export const AvailabilityScheduleData = {
  name: "AvailabilityScheduleData",
  initialState: initState,
  section: [
    {
      title: "Schedule & Capacity Section",
      row: {},
      style: {
        sectionStyle: "verticle-form mb-3 form-card row",
      },
      wrapperTemplate: <TitleWrapper title="Schedule & Capacity" />,
      fields: [
        {
          id: "isRedirection",
          label: "Redirection",
          Field_Name: "Redirection",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "isRedirection",
          fieldSetting: {
            allowSpace: true,
            options: [
              { value: "yes", label: "Yes" },
              { value: "no", label: "No" },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-6 radioStyle",
          },
        },
        {
          id: "scheduleType",
          label: "",
          Field_Name: "Schedule Type",
          fieldType: FormFieldTypes.RADIOBUTTON,
          dataField: "scheduleType",
          fieldSetting: {
            allowSpace: true,
            options: [
              { label: "Physical", value: "physical", isDisable: false, optionClass: "", },
              { label: "Zoom", value: "zoom", isDisable: false, optionClass: "", },
              { label: "Hybrid", value: "hybrid", isDisable: false, optionClass: "", },
            ],
          },
          validation: [{ type: validationTypes.REQUIRE }],
          style: {
            containerCss: "col-lg-12 radioStyle",
          },
        },
      ],
    },
  ],
  formSetting: {
    isViewOnly: false,
  },
};
